module.exports = __webpack_public_path__ + "static/media/ic_qr_fail.f047ed28.svg";